(() => {
  const root = document.documentElement;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const io = 'IntersectionObserver' in window;

  const reveals = document.querySelectorAll('[data-sr-reveal]');
  if (io && !window.Shopify?.designMode) {
    root.classList.add('sr-js');
    const seen = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        e.target.classList.add('is-in');
        seen.unobserve(e.target);
      }
    }, { rootMargin: '0px 0px -8% 0px' });
    reveals.forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight) el.classList.add('is-in');
      else seen.observe(el);
    });
  } else {
    root.classList.add('sr-js');
    reveals.forEach((el) => el.classList.add('is-in'));
  }

  const fmt = new Intl.NumberFormat('en-GB');
  const count = (el, target) => {
    const dur = 1600;
    const t0 = performance.now();
    const tick = (now) => {
      const p = Math.min((now - t0) / dur, 1);
      const eased = 1 - Math.pow(1 - p, 4);
      el.textContent = fmt.format(Math.round(target * eased));
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const counters = [...document.querySelectorAll('[data-sr-count]')].filter((el) => /^\d+$/.test(el.dataset.srCount));
  if (io && !reduce && !window.Shopify?.designMode && counters.length) {
    const obs = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (!e.isIntersecting) continue;
        count(e.target, Number(e.target.dataset.srCount));
        obs.unobserve(e.target);
      }
    }, { rootMargin: '0px 0px -8% 0px' });
    counters.forEach((el) => {
      if (el.getBoundingClientRect().top < innerHeight) return;
      el.textContent = fmt.format(0);
      obs.observe(el);
    });
  }

  const dock = document.querySelector('[data-sr-dock]');
  const footer = document.querySelector('.sr-footer');
  if (dock && footer && io) {
    new IntersectionObserver(([e]) => dock.classList.toggle('is-hidden', e.isIntersecting)).observe(footer);
    document.addEventListener('focusin', (e) => {
      if (e.target.matches('input, textarea, select')) dock.classList.add('is-hidden');
    });
    document.addEventListener('focusout', () => dock.classList.remove('is-hidden'));
  }

  const SOUTH_WEST = /^(EX|PL|TQ|TR|TA|BA|DT|BH|BS)\d/i;
  const inArea = (input) => SOUTH_WEST.test(input.value.replace(/\s+/g, ''));
  const holdForArea = (input, note) => {
    if (!note || inArea(input) || note.dataset.shown) return false;
    note.hidden = false;
    note.dataset.shown = '1';
    note.scrollIntoView({ block: 'nearest', behavior: reduce ? 'auto' : 'smooth' });
    return true;
  };
  const resetArea = (note) => {
    if (!note) return;
    note.hidden = true;
    delete note.dataset.shown;
  };

  const starters = document.querySelectorAll('[data-sr-postcode-form]');
  starters.forEach((f) => {
    const input = f.querySelector('[data-sr-postcode]');
    const err = f.querySelector('.sr-error');
    const note = f.querySelector('[data-sr-area]');
    f.noValidate = true;
    f.addEventListener('submit', (e) => {
      input.value = input.value.trim().toUpperCase();
      const ok = input.checkValidity();
      err.hidden = ok;
      input.setAttribute('aria-invalid', String(!ok));
      if (!ok) {
        e.preventDefault();
        input.focus();
      } else if (holdForArea(input, note)) {
        e.preventDefault();
      } else if (!inArea(input) && !f.elements.area) {
        f.insertAdjacentHTML('beforeend', '<input type="hidden" name="area" value="outside">');
      }
    });
    input.addEventListener('input', () => {
      resetArea(note);
      if (!err.hidden && input.checkValidity()) {
        err.hidden = true;
        input.setAttribute('aria-invalid', 'false');
      }
    });
  });

  const primaries = document.querySelectorAll('[data-sr-postcode-form], [data-sr-primary]');
  if (io && primaries.length) {
    const visible = new Set();
    const watch = new IntersectionObserver((entries) => {
      for (const e of entries) e.isIntersecting ? visible.add(e.target) : visible.delete(e.target);
      root.classList.toggle('sr-form-in-view', visible.size > 0);
    });
    primaries.forEach((f) => watch.observe(f));
  }

  document.querySelectorAll('[data-sr-menu]').forEach((menu) => {
    menu.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu.open) {
        menu.open = false;
        menu.querySelector('summary').focus();
      }
    });
  });

  document.querySelectorAll('[data-sr-gallery]').forEach((gallery) => {
    const items = [...gallery.querySelectorAll('.sr-gallery__item')];
    const chips = gallery.querySelectorAll('[data-sr-filter]');
    chips.forEach((chip) => chip.addEventListener('click', () => {
      chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
      items.forEach((li) => { li.hidden = Boolean(chip.dataset.srFilter) && li.dataset.tag !== chip.dataset.srFilter; });
    }));

    const box = gallery.querySelector('[data-sr-lightbox]');
    if (!box || typeof box.showModal !== 'function') return;
    const img = box.querySelector('[data-sr-lightbox-img]');
    const caption = box.querySelector('[data-sr-lightbox-caption]');
    const count = box.querySelector('[data-sr-lightbox-count]');
    const prev = box.querySelector('[data-sr-lightbox-prev]');
    const fwd = box.querySelector('[data-sr-lightbox-next]');
    let list = [];
    let at = 0;
    let opener = null;

    const show = (i, dir = 0, instant = false) => {
      at = (i + list.length) % list.length;
      const link = list[at];
      if (instant) {
        img.classList.remove('is-swapping');
        img.src = link.href;
      } else if (img.getAttribute('src') !== link.href) {
        img.style.setProperty('--sr-swap', reduce ? '0' : `${dir * 1.5}rem`);
        img.classList.add('is-swapping');
        img.onload = img.onerror = () => requestAnimationFrame(() => img.classList.remove('is-swapping'));
        img.src = link.href;
      }
      img.alt = link.querySelector('img')?.alt || '';
      caption.textContent = link.dataset.caption || '';
      count.textContent = `${at + 1} of ${list.length}`;
      [1, -1].forEach((d) => { new Image().src = list[(at + d + list.length) % list.length].href; });
    };

    gallery.addEventListener('click', (e) => {
      const link = e.target.closest('[data-sr-photo]');
      if (!link || e.metaKey || e.ctrlKey || e.shiftKey || e.button) return;
      e.preventDefault();
      list = [...gallery.querySelectorAll('.sr-gallery__item:not([hidden]) [data-sr-photo]')];
      opener = link;
      prev.hidden = fwd.hidden = list.length < 2;
      show(list.indexOf(link));
      box.showModal();
      root.setAttribute('scroll-lock', '');
    });
    box.addEventListener('close', () => {
      root.removeAttribute('scroll-lock');
      opener?.focus({ preventScroll: true });
    });
    prev.addEventListener('click', () => show(at - 1, -1));
    fwd.addEventListener('click', () => show(at + 1, 1));
    box.querySelector('[data-sr-lightbox-close]').addEventListener('click', () => box.close());
    box.addEventListener('keydown', (e) => {
      if (list.length < 2) return;
      if (e.key === 'ArrowLeft') show(at - 1, -1, true);
      if (e.key === 'ArrowRight') show(at + 1, 1, true);
    });

    let x0 = null;
    let y0 = 0;
    let t0 = 0;
    let swiped = false;
    box.addEventListener('pointerdown', (e) => { x0 = e.clientX; y0 = e.clientY; t0 = e.timeStamp; swiped = false; });
    box.addEventListener('pointerup', (e) => {
      if (x0 === null) return;
      const dx = e.clientX - x0;
      const flick = Math.abs(dx) > 20 && Math.abs(dx) / Math.max(e.timeStamp - t0, 1) > 0.11;
      x0 = null;
      if (list.length > 1 && (Math.abs(dx) > 50 || flick) && Math.abs(dx) > Math.abs(e.clientY - y0)) {
        swiped = true;
        show(at + (dx < 0 ? 1 : -1), dx < 0 ? 1 : -1);
      }
    });
    box.addEventListener('pointercancel', () => { x0 = null; });
    box.addEventListener('click', (e) => {
      if (swiped) { swiped = false; return; }
      if (e.target === box || e.target.classList.contains('sr-lightbox__figure')) box.close();
    });
  });

  const form = document.querySelector('[data-sr-stepper]');
  if (!form) return;

  const postcode = form.querySelector('[data-sr-postcode]');
  const fromUrl = new URLSearchParams(location.search).get('postcode');
  if (postcode && fromUrl) postcode.value = fromUrl.toUpperCase().slice(0, 8);

  const done = form.querySelector('[data-sr-done], [data-sr-errors]');
  if (done) {
    done.scrollIntoView({ block: 'center' });
    done.focus({ preventScroll: true });
  }

  const steps = [...form.querySelectorAll('[data-sr-step]')];
  if (!steps.length) return;
  const back = form.querySelector('[data-sr-back]');
  const next = form.querySelector('[data-sr-next]');
  const bars = form.querySelectorAll('.sr-quote__progress li');
  const status = form.querySelector('[data-sr-status]');
  console.assert(bars.length === steps.length, `Quote form: ${bars.length} progress bars for ${steps.length} steps`);
  form.noValidate = true;
  let current = 0;

  const services = [...form.querySelectorAll('[data-sr-service]')];
  const wanted = new URLSearchParams(location.search).get('service');
  services.forEach((s) => { if (s.dataset.srService === wanted) s.checked = true; });
  form.querySelectorAll('[data-sr-req]').forEach((i) => { i.required = true; });
  const syncServices = () => steps.forEach((s, n) => {
    s.disabled = Boolean(s.dataset.srFor) && !services.some((c) => c.checked && c.dataset.srService === s.dataset.srFor);
    if (bars[n]) bars[n].classList.toggle('is-off', s.disabled);
  });
  const nextOn = (from, dir) => {
    let i = from + dir;
    while (steps[i]?.disabled) i += dir;
    return i;
  };

  const seenSteps = new Set();
  const trackStep = (step) => {
    if (seenSteps.has(step)) return;
    seenSteps.add(step);
    const on = steps.filter((s) => !s.disabled);
    const data = {
      step: on.indexOf(step) + 1,
      step_name: step.querySelector('legend').textContent.replace(/^\d+/, '').trim(),
      services: services.filter((c) => c.checked).map((c) => c.dataset.srService),
      site: location.hostname,
    };
    console.assert(data.step > 0 && data.step_name, 'Quote analytics: step number and name');
    window.Shopify?.analytics?.publish?.('quote_step_viewed', data);
  };

  const fieldsOf = (scope) => [...scope.querySelectorAll('[data-sr-field]')];
  const inputsOf = (field) => [...field.querySelectorAll('input, textarea')];
  const valid = (field) => (field.hasAttribute('data-sr-any') ? inputsOf(field).some((i) => i.checked) : inputsOf(field).every((i) => i.checkValidity()));
  const checkField = (field) => {
    const ok = valid(field);
    const err = field.querySelector('.sr-error');
    if (err) err.hidden = ok;
    inputsOf(field).forEach((i) => i.setAttribute('aria-invalid', String(!ok)));
    return ok;
  };
  const checkStep = (step) => {
    const bad = fieldsOf(step).filter((f) => !checkField(f));
    if (bad.length) bad[0].querySelector('input, textarea').focus();
    return bad.length === 0;
  };

  const show = (i, dir = 1) => {
    const on = steps.filter((s) => !s.disabled);
    steps.forEach((s, n) => {
      s.classList.toggle('is-current', n === i);
      s.classList.toggle('is-back', n === i && dir < 0);
    });
    on.forEach((s, n) => { s.querySelector('legend .sr-junction').textContent = n + 1; });
    bars.forEach((b, n) => b.classList.toggle('is-done', n <= i));
    back.hidden = i === 0;
    form.classList.toggle('is-last', i === steps.length - 1);
    current = i;
    const legend = steps[i].querySelector('legend');
    if (status) status.textContent = `Step ${on.indexOf(steps[i]) + 1} of ${on.length}: ${legend.textContent.replace(/^\d+/, '').trim()}`;
    trackStep(steps[i]);
  };

  form.addEventListener('change', (e) => {
    if (e.target.matches('[data-sr-service]')) syncServices();
    const field = e.target.closest('[data-sr-field]');
    if (field && field.querySelector('[aria-invalid="true"]')) checkField(field);
  });
  form.addEventListener('input', (e) => {
    const field = e.target.closest('[data-sr-field]');
    if (field && e.target.getAttribute('aria-invalid') === 'true') checkField(field);
  });
  form.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && e.target.matches('input:not([type="checkbox"]):not([type="radio"])') && !form.classList.contains('is-last')) {
      e.preventDefault();
      next.click();
    }
  });

  const areaNote = form.querySelector('[data-sr-area]');
  const outside = form.querySelector('[data-sr-outside]');
  if (postcode) postcode.addEventListener('input', () => resetArea(areaNote));
  if (areaNote && new URLSearchParams(location.search).get('area') === 'outside') areaNote.dataset.shown = '1';
  areaNote?.querySelector('[data-sr-area-go]')?.addEventListener('click', () => next.click());

  next.addEventListener('click', () => {
    if (!checkStep(steps[current])) return;
    if (postcode && steps[current].contains(postcode) && holdForArea(postcode, areaNote)) return;
    show(nextOn(current, 1));
    steps[current].querySelector('input').focus({ preventScroll: true });
    form.closest('.sr-sign').scrollIntoView({ block: 'start', behavior: reduce ? 'auto' : 'smooth' });
  });
  back.addEventListener('click', () => {
    show(nextOn(current, -1), -1);
    steps[current].querySelector('input').focus({ preventScroll: true });
  });
  form.addEventListener('submit', (e) => {
    if (outside && postcode) outside.value = inArea(postcode) ? '' : 'Yes';
    const firstBad = steps.findIndex((s) => !s.disabled && fieldsOf(s).some((f) => !valid(f)));
    if (firstBad !== -1) {
      e.preventDefault();
      show(firstBad, firstBad < current ? -1 : 1);
      checkStep(steps[firstBad]);
    }
  });

  form.classList.add('is-ready');
  syncServices();
  show(0);

  if (fromUrl && postcode.checkValidity()) {
    const open = fieldsOf(steps[0]).find((f) => !valid(f));
    if (open) open.querySelector('input').focus();
  }
})();
